
import { Options, Vue } from "vue-class-component";
import OverlayPanel from "primevue/overlaypanel";
import {
  printReceiptChannel,
  SttHistorySuccessBooking
} from "@/domain/entities/PrintReceipt";
import { ListBookingHistoryDetailApiRequest } from "@/data/payload/api/PrintReceiptApiRequest";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import {
  convertDecimalWithComma,
  parsingErrorResponse
} from "@/app/infrastructures/misc/Utils";
import TableHistorySuccessBooking from "./table-history-success-booking.vue";
import { PrintReceiptController } from "@/app/ui/controllers/PrintReceiptController";
import store from "@/store";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { formatShortName } from "@/app/ui/modules/receipt-v2/module";
import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";
import formatPrice from "@/app/infrastructures/misc/common-library/v2/FormatPrice";

@Options({
  components: {
    OverlayPanel,
    TableHistorySuccessBooking
  },
  watch: {
    listSttSuccessBooking() {
      this.syncFetch();
    },
    visibleToastHistorySuccessBooking(val: boolean) {
      if (val) {
        this.onHideToastHistorySuccessBooking();
      }
    }
  }
})
class ListHistorySuccessBooking extends Vue {
  mounted() {
    this.onRegisterTable();
    //this.onRegisterChannel();
  }

  onRegisterChannel() {
    printReceiptChannel.onMessage((message) => {
      switch (message.type) {
        case "SYNC_LIST":
          store.commit(
            "PrintReceipt/SET_LIST_STT_SUCCESS_BOOKING",
            message.payload
          );

          if (!message.payload.length) {
            this.onReset();
          }
          break;

        case "SYNC_LAST_DATE":
          store.commit(
            "PrintReceipt/SET_LAST_DATE_STT_SUCCESS_BOOKING",
            message.payload
          );
          break;
      }
    });
  }

  onRegisterTable() {
    this.refsTableHistorySuccessBooking = this.$refs?.[
      "table-history-success-booking"
    ];

    if (!this.refsTableHistorySuccessBooking) return;

    this.refsTableHistorySuccessBooking.$watch("visible", (val: boolean) => {
      if (val) {
        PrintReceiptController.setSelectedSttHistorySuccessBooking([]);
        this.getList();
      }
    });
  }

  get showListHistorySuccessBooking() {
    const flag = FlagsPermissionBooking.flag_booking_print_invoice_receipt_enabled.isEnabled();
    const { isPosAccount } = AccountController.accountData;
    return flag && isPosAccount;
  }

  refsTableHistorySuccessBooking: any = null;
  openTable(event: Event) {
    if (!this.refsTableHistorySuccessBooking) return;

    PrintReceiptController.setVisibleToastHistorySuccessBooking(false);
    this.refsTableHistorySuccessBooking?.toggle(event);
  }
  hideTable() {
    if (!this.refsTableHistorySuccessBooking) return;

    this.refsTableHistorySuccessBooking?.hide();
  }

  get badgeData() {
    const total = PrintReceiptController.listSttSuccessBooking.length;

    if (!total) return { value: "", style: {} };

    const value = total > 99 ? "99+" : String(total);

    switch (value.length) {
      case 1:
        return {
          value,
          style: {
            fontSize: "11px"
          }
        };
      case 2:
        return {
          value,
          style: {
            fontSize: "9px"
          }
        };
      default:
        return {
          value,
          style: {
            fontSize: "8px"
          }
        };
    }
  }

  get column(): any {
    return [
      {
        name: "",
        class: "w-8",
        isCheckbox: true
      },
      {
        name: this.$t("printReceipt.booking.table.sttNo"),
        class: "w-44",
        slotName: "stt-no"
      },
      {
        name: this.$t("printReceipt.booking.table.senderName"),
        class: "w-44",
        render: (item: SttHistorySuccessBooking) =>
          `<div class="flex items-start text-sm text-black-lp-300">${formatShortName(
            item.senderName
          )} - ${this.onMaskingPhoneNumber(item.senderPhone)}</div>`
      },
      {
        name: this.$t("printReceipt.booking.table.shipmentType"),
        slotHeaderName: "product-type",
        class: "w-48",
        render: (item: SttHistorySuccessBooking) =>
          `<div class="flex items-start text-sm text-black-lp-300">${
            item.productType
          } - ${convertDecimalWithComma(item.chargeableWeight, 2)} kg</div>`
      },
      {
        name: this.$t("printReceipt.booking.table.invoice"),
        class: "w-28",
        render: (item: SttHistorySuccessBooking) => {
          let payment = formatPrice(
            item.amount,
            "",
            AccountController.accountData.accountCurrency
          );

          if (item.isCashless) {
            payment = this.$t("printReceipt.booking.table.paidViaApp");
          } else if (item.isDfod || item.isCod) {
            payment = this.$t("printReceipt.booking.table.paidByRecipient");
          }

          return `<div class="flex items-start text-sm text-black-lp-300">${payment}</div>`;
        }
      },
      {
        name: this.$t("printReceipt.booking.table.activity"),
        class: "w-40",
        slotName: "action"
      }
    ];
  }

  listData = new ResponsePayloadV2();
  get listSttSuccessBooking() {
    return PrintReceiptController.listSttSuccessBooking;
  }
  async getList() {
    try {
      if (!this.listSttSuccessBooking.length) return;

      this.listData.loading = true;

      const res = await PrintReceiptController.getBookingHistoryDetail(
        new ListBookingHistoryDetailApiRequest({
          sttNumbers: this.listSttSuccessBooking
        })
      );
      this.listData.data = res.data.map(
        (item: SttHistorySuccessBooking) =>
          new SttHistorySuccessBooking({
            ...item,
            selected: false
          })
      );
    } catch (err) {
      this.listData.errorType = parsingErrorResponse(err).type;
    } finally {
      this.listData.loading = false;
    }
  }
  onMaskingPhoneNumber(phone: string) {
    if (!phone) return "";
    return phone.replace(
      /^(\d{2})(\d+)(\d{3})$/,
      (_, start, middle, end) => start + "*".repeat(middle.length) + end
    );
  }

  isFetching = false;
  async syncFetch() {
    const invalidSync =
      this.isFetching ||
      !this.listSttSuccessBooking.length ||
      !this.refsTableHistorySuccessBooking?.visible;

    if (invalidSync) return;

    this.isFetching = true;

    try {
      await this.getList();
    } finally {
      this.isFetching = false;
    }
  }

  get latestSttNumberSuccessBooking(): string {
    const list = PrintReceiptController.listSttSuccessBooking;
    return list.length ? list[0] : "";
  }
  get visibleToastHistorySuccessBooking() {
    return PrintReceiptController.visibleToastHistorySuccessBooking;
  }
  onHideToastHistorySuccessBooking() {
    setTimeout(() => {
      PrintReceiptController.setVisibleToastHistorySuccessBooking(false);
    }, 3000);
  }
  onReset() {
    this.listData = new ResponsePayloadV2();
  }
}

export default ListHistorySuccessBooking
